import { render } from "./OrderTote.vue?vue&type=template&id=9c2ad708"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/OrderTote.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9c2ad708"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9c2ad708', __exports__)) {
    api.reload('9c2ad708', __exports__)
  }
  
  module.hot.accept("./OrderTote.vue?vue&type=template&id=9c2ad708", () => {
    api.rerender('9c2ad708', render)
  })

}


export default __exports__